'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StepLabel = function (_React$Component) {
  (0, _inherits3.default)(StepLabel, _React$Component);

  function StepLabel() {
    (0, _classCallCheck3.default)(this, StepLabel);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(StepLabel).apply(this, arguments));
  }

  (0, _createClass3.default)(StepLabel, [{
    key: 'getLabelIndicator',
    value: function getLabelIndicator() {
      var _props = this.props;
      var completed = _props.completed;
      var editable = _props.editable;
      var stepNumber = _props.stepNumber;

      var indicator = _react2.default.createElement(
        'span',
        { className: 'mdl-step__label-indicator-content' },
        stepNumber
      );

      if (completed) {
        var icon = editable ? 'edit' : 'check';

        indicator = _react2.default.createElement(
          'i',
          { className: 'material-icons mdl-step__label-indicator-content' },
          icon
        );
      }

      return _react2.default.createElement(
        'span',
        { className: 'mdl-step__label-indicator' },
        indicator
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var children = _props2.children;
      var isActive = _props2.isActive;
      var isLastChild = _props2.isLastChild;

      return _react2.default.createElement(
        'span',
        { className: 'mdl-step__label' },
        children,
        this.getLabelIndicator(),
        !isActive && !isLastChild ? _react2.default.createElement(
          'div',
          { style: {
              position: 'absolute',
              left: 0,
              width: '1px',
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              margin: '36px 4px 0 37px',
              height: '40px'
            } },
          ' '
        ) : null
      );
    }
  }]);
  return StepLabel;
}(_react2.default.Component);

StepLabel.propTypes = {
  editable: _react.PropTypes.bool,
  completed: _react.PropTypes.bool,
  stepNumber: _react.PropTypes.number.isRequired,
  children: _react.PropTypes.object
};

exports.default = StepLabel;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-stepper/dist/step_label.js
// module id = 359
// module chunks = 0